const submenuOffset = () => {
	const header = document.getElementById('top').offsetHeight
	const submenues = document.querySelectorAll('.sf-menu > li > .sub-menu')
	
	submenues.forEach(submenu => {
		submenu.style.top = header + 'px'
	})	
}

document.addEventListener('DOMContentLoaded', submenuOffset)
window.addEventListener('scroll', submenuOffset)
window.addEventListener('resize', submenuOffset)